import { HeaderKeyControl } from '@/components/HeaderKeyControl';
import {
  useOrganizationApiKeyStatus,
  useGenerateOrganizationApiKey,
} from '@/hooks/api/useApiKeys';
import { useIsSupport } from '@/hooks/useRoleCheck';

interface OrganizationKeyControlProps {
  organizationId: string;
}

/**
 * Organization API Key Control Component
 *
 * Wraps HeaderKeyControl with organization-specific API key functionality.
 * Handles organization API key status and generation.
 *
 * @param organizationId - The organization ID for API key operations
 */
export function OrganizationKeyControl({
  organizationId,
}: OrganizationKeyControlProps) {
  const statusQuery = useOrganizationApiKeyStatus(organizationId);
  const generateMutation = useGenerateOrganizationApiKey(organizationId);
  const { isSupport } = useIsSupport(organizationId);

  return (
    <HeaderKeyControl
      statusQuery={statusQuery}
      generateMutation={generateMutation}
      disableGenerate={isSupport}
    />
  );
}
